import axios from "axios";

const instance = axios.create({
  baseURL: "https://tinder-backend-michael.herokuapp.com",
});

export default instance;
